import {Base64Object, validateBase64ObjectFileSize} from '@coolcolduk/util';
import {UserSoundType} from '@cp/model';
import {env} from '../../config/env';
import deleteStorageFilesByPrefix from '../../helper/firebase/storage/deleteStorageFilesByPrefix';
import uploadStorageBase64 from '../../helper/firebase/storage/uploadStorageBase64';
import extractFileExtension from '../../utils/file/extractFileExtension';

/**
 * Uploads sound file to Storage and returns the download URL.
 * deletes any existing file for this sound type before uploading the new file.
 * Caller should update user doc with the corresponding sound URL field or deleteField() when clearing.
 */
export default async function uploadUserSoundFile(
  uid: string,
  soundType: UserSoundType,
  soundFile: Base64Object | undefined,
): Promise<string | undefined> {
  await deleteStorageFilesByPrefix(`private/${uid}`, soundType.toLowerCase());
  if (!soundFile) {
    return undefined;
  }
  validateBase64ObjectFileSize(
    soundFile,
    env.sizeLimit.sound,
    `Sound file size exceeds limit of ${env.sizeLimit.sound} bytes`,
  );
  const ext = extractFileExtension(soundFile.name);
  const path = `private/${uid}/${soundType.toLowerCase()}.${ext}`;
  return uploadStorageBase64(soundFile, path);
}
